"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconDistrictHeatingOutagesOnTheMap = function IconDistrictHeatingOutagesOnTheMap(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M24 5c-7.34 0-13.53 6.922-13.54 14.829 0 3.233 2.027 7.952 6.008 14.17q.327.51.683 1.05l.362.546q.4.6.83 1.227a194 194 0 0 0 3.339 4.722l1.52 2.058.824 1.094 1.636-2.326q.33-.474.693-1a312 312 0 0 0 3.383-4.99l.523-.792q.541-.825 1.03-1.588C35.274 27.78 37.3 23.062 37.3 19.83 37.3 11.88 31.308 5 24 5m0 2c6.137 0 11.3 5.928 11.3 12.83 0 2.672-1.81 6.953-5.412 12.65l-.28.44q-.322.503-.668 1.033l-.869 1.323a310 310 0 0 1-3.361 4.957l-.734 1.058-.678-.925a192 192 0 0 1-3.305-4.672l-.55-.812-.267-.398q-.543-.813-1.024-1.564l-.554-.876c-3.42-5.48-5.138-9.61-5.138-12.214C12.47 12.981 17.817 7 24 7m-.12 3.66a8.48 8.48 0 1 0 0 16.96 8.48 8.48 0 0 0 0-16.96m0 1a7.48 7.48 0 1 1 0 14.96 7.48 7.48 0 0 1 0-14.96",
    clipRule: "evenodd"
  })));
};

export { IconDistrictHeatingOutagesOnTheMap, IconDistrictHeatingOutagesOnTheMap as default };
